import { useFeatureToggles } from "@grandvisionhq/state";
function useAdditionalLoginProviders() {
  const { featureConfigs } = useFeatureToggles();
  const { additionalLoginProviders } = featureConfigs;
  const isProviderEnabled = (provider) => !!additionalLoginProviders?.includes(provider);
  return {
    hasProviders: !!additionalLoginProviders?.length,
    isProviderEnabled
  };
}
export {
  useAdditionalLoginProviders
};
//# sourceMappingURL=use-additional-login-providers.js.map
